import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedPassword = mutatorAction('updateAdvancedPassword', function (password) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.password = password;
});
//# sourceMappingURL=updateAdvancedPassword.js.map